import * as e from "react";
const l = (t) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...t
  },
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M8.02105 17.0505C8.02105 12.3551 4.43684 8.5317 0 8.5317L0.66316 8.49816C4.6579 8.146 7.83158 4.67474 8.00527 0.381787V-0.00390625C8.00527 4.52382 11.3211 8.21308 15.5211 8.49816L16.0263 8.51492C11.6211 8.53169 8.02105 12.3551 8.02105 17.0505Z",
      fill: "#333333"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M15.3196 23.9955C15.3196 21.2199 13.2009 18.9597 10.5781 18.9597L10.9701 18.9399C13.3316 18.7317 15.2076 16.6798 15.3103 14.1421V13.9141C15.3103 16.5906 17.2704 18.7714 19.7531 18.9399L20.0518 18.9498C17.4477 18.9597 15.3196 21.2199 15.3196 23.9955Z",
      fill: "#333333"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M20.7635 15.4378C20.7635 13.5411 19.3157 11.9967 17.5234 11.9967L17.7913 11.9832C19.405 11.8409 20.6869 10.4387 20.7571 8.70463V8.54883C20.7571 10.3778 22.0965 11.868 23.793 11.9832L23.9971 11.9899C22.2177 11.9967 20.7635 13.5411 20.7635 15.4378Z",
      fill: "#333333"
    }
  )
), a = l;
export {
  a as default
};
